import { useEffect, useState } from "react";
import CustomListPolicyCustomer from "../../Components/custom-box/CustomListPolicyCustomer";
import ImageBackground from '../../Assets/Images/background-contnt.png'
import { t } from "i18next";
import '../../Assets/Styles/Customer/customer-policy-info.css';
import * as CustomerService from '../../Services/customer-service';
import { useTranslation } from "react-i18next";
import LoadingOverlay from "react-loading-overlay-nextgen";
import useWindowDimensions from "../../Layouts/useWindowDimension";
import CustomNav from "../../Components/custom-nav/CustomNav";
import FooterCustomer from "../../Layouts/footer/FooterCustomer";
import '../../Assets/Styles/Customer/font-size.css'
import { countTimeExpired } from "../../Services/service";

export default function CustomerPolicy() {
    const [objectDto, setObjectDto] = useState(localStorage.getItem("aaa") !== null ? JSON.parse(localStorage.getItem("aaa")) : null);
    const [activeItem, setActiveItem] = useState({ title: t("policycustomer"), icon: <i class="fa fa-file-text" aria-hidden="true"></i>, content: "", no: 1 });
    const { height, width } = useWindowDimensions();
    const [listPolicy, setListPolicy] = useState([]);
    countTimeExpired(objectDto, setObjectDto);
    useEffect(() => {
        document.title = "Phu Hung Life - Hop Dong"
    }, []);
    useEffect(() => {
        if (listPolicy !== null && listPolicy.length === 0)
            CustomerService.getPolicyListById(objectDto, setObjectDto, setListPolicy);
        if (listPolicy !== null && listPolicy.length !== 0)
            listPolicy.sort((a, b) => a.poNumber > b.poNumber ? 1 : -1);
    }, []);
    const { i18n } = useTranslation();
    useEffect(() => {
    }, [i18n]);
    const divStyle = {
        backgroundImage: `url(${ImageBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100vw',
        height: height,
        backgroundRepeat: 'no-repeat'
    };
    return (
        <>
            <div className='nav-container' style={{ height: height }}>
                <CustomNav activeItem={activeItem} setActiveItem={setActiveItem} objectDto={objectDto} setObjectDto={setObjectDto} width={width} height={height} />
                <div className="customer-info-container" style={divStyle}>
                    {
                        listPolicy.length !== 0 ?
                            <div className="container-cus-policy-info">
                                <div className="col-md-12 title-header">
                                    <div className="col-md-6 col-start header-title-customer"> <span>{t("listpolicy")}</span> </div>
                                    <div className="col-md-6 col-end header-title-customer">
                                        <span className="header-span-customer" style={{ fontWeight: "300" }}>
                                            {t("countpolicy1")}
                                            <span style={{ fontWeight: 'bold' }}>
                                                {listPolicy.length < 10 ? "0" + listPolicy.length : listPolicy.length}
                                            </span>
                                            {t("countpolicy2")}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-12 form-group" style={900 < width < 1100 ? { paddingBottom: "7%" } : { paddingBottom: "5%" }}>
                                    {
                                        listPolicy.map((item, index) => {
                                            if (index === 0) <div style={{ marginTop: "20%" }} />
                                            return <CustomListPolicyCustomer policy={item} index={index + 1} />
                                        })
                                    }
                                </div>
                            </div>
                            :
                            <LoadingOverlay className="loading_overlay_content_customer" active={true} spinner text={t("loading")} />
                    }
                </div>
            </div>
            <FooterCustomer />
        </>
    )
};
